import { LoginButton } from "@/components/LoginButton/LoginButton";
import { PageWithCustomerLogo } from "@/components/PageWithCustomerLogo/PageWithCustomerLogo";
import { PageWithScene } from "@/components/PageWithScene/PageWithScene";
import { useSettings } from "@/context/settings";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import css from "./index.module.scss";

export const Route = createFileRoute("/login/")({
  validateSearch: z.object({
    type: z.literal("signeringsportal").optional(),
    url: z.string().optional(),
    error: z.string().optional(), // Added by the API login handler
  }),
  head: () => ({
    meta: [{ title: "Logg inn | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { type, url, error } = Route.useSearch();
  const { customer } = useSettings();

  if (type === "signeringsportal") {
    return (
      <PageWithCustomerLogo customer={customer}>
        <p className={css.text}>
          {customer.name} behøver din signatur på dokumentene som skal tinglyses hos Kartverket.
        </p>
        <LoginButton successUrl={url ?? "/"} errorUrl={window.location.href} />

        {error != null && <p>{error}</p>}
      </PageWithCustomerLogo>
    );
  }

  return (
    <PageWithScene heading="Alice & Bob" scene="Alice-Bob">
      <LoginButton successUrl={url ?? "/"} errorUrl={window.location.href} />

      {error != null && <p>{error}</p>}
    </PageWithScene>
  );
}
